import * as React from 'react'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { PurchaseCard } from './purchase-card'
import type { PurchaseCardVariant } from './purchase-card'

interface CoinPackageCardProps {
  coins: number
  price: string
  unitPrice: string
  variant?: PurchaseCardVariant
  onPurchase: (e: React.MouseEvent<HTMLButtonElement>) => void
  loading?: boolean
  success?: boolean
  isHighestValue?: boolean
  ref?: React.Ref<HTMLDivElement>
}

export function CoinPackageCard({
  coins,
  price,
  unitPrice,
  variant = 'default',
  onPurchase,
  loading = false,
  success = false,
  isHighestValue = false,
  ref,
}: CoinPackageCardProps) {
  const t = useStudioTranslate()

  return (
    <PurchaseCard.Root variant={variant} ref={ref}>
      <PurchaseCard.Title variant={variant}>
        {t('studio.coins.top_up_dialog.coins_label', {
          amount: coins.toLocaleString(),
        })}
      </PurchaseCard.Title>
      <PurchaseCard.Price variant={variant} price={price} />
      <PurchaseCard.UnitPrice variant={variant}>{unitPrice}</PurchaseCard.UnitPrice>
      <PurchaseCard.BuyButton
        variant={variant}
        onClick={onPurchase}
        loading={loading}
        disabled={loading}
        success={success}
        isHighestValue={isHighestValue}
      >
        {t('studio.coins.top_up_dialog.one_time.buy')}
      </PurchaseCard.BuyButton>
    </PurchaseCard.Root>
  )
}
